// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1WIXN","validationTips":"StatementDescriptor_validationTips__2VDp9"};